import { Control } from "./control";
import { ProgressBar } from "./progressBar";
import { VolumeControl } from "./volumeControl";

export default function AudioPlayer() {
  return (
    <div className="w-full flex items-center justify-between gap-4 m-auto flex-1 px-6 md:px-12 lg:px-24 py-8 sticky top-[80px] md:top-[96px] z-40 bg-custom-bg">
      <Control />
      <div className="flex-1">
        <ProgressBar />
      </div>
      <VolumeControl />
    </div>
  );
}
